import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./auth";
import Sidebar from "./components/layout/Sidebar";
import Header from "./components/layout/Header";
import NewProjectModal from "./components/NewProjectModal";
import QuickPaymentModal from "./components/QuickPaymentModal";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import Employers from "./pages/Employers";
import Subcontractors from "./pages/Subcontractors";
import Payments from "./pages/Payments";
import Finance from "./pages/Finance";
import Categories from "./pages/Categories";
import Quotes from "./pages/Quotes";
import Trash from "./pages/Trash";
import ExcelImport from "./pages/ExcelImport";
import Users from "./pages/Users";
import Leave from "./pages/Leave";
import Login from "./pages/Login";
import { COMPANIES } from "./api";
import "@/App.css";

const PAGES = {
  dashboard: Dashboard, projects: Projects, employers: Employers, subcontractors: Subcontractors,
  payments: Payments, finance: Finance, quotes: Quotes, categories: Categories, trash: Trash, import: ExcelImport, users: Users, leave: Leave,
};
const PAGE_ROLES = { import: ["admin"], categories: ["admin", "project_manager"], trash: ["admin", "project_manager"], quotes: ["admin", "project_manager", "finance"] };

function Shell() {
  const { user } = useAuth();
  const [active, setActiveKey] = useState("dashboard");
  const [openProject, setOpenProject] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [modal, setModal] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [company, setCompany] = useState("");
  const userId = user?.id;
  const isEmployee = user?.role === "calisan";

  useEffect(() => {
    setActiveKey(user?.role === "calisan" ? "leave" : "dashboard"); setOpenProject(null); setModal(null);
    const my = (user?.companies && user.companies.length) ? user.companies : COMPANIES;
    setCompany(my.length === 1 ? my[0] : "");
  }, [userId]);

  if (user === null) return <div className="loading-screen" data-testid="auth-loading">Yükleniyor…</div>;
  if (!user) return <><Login /><Toaster position="bottom-right" richColors /></>;

  const setActive = (key, projectId = null) => {
    if (isEmployee && key !== "leave") return;
    if (key === "users" && !user.is_super_admin) return;
    if (PAGE_ROLES[key] && !PAGE_ROLES[key].includes(user.role)) return;
    setOpenProject(projectId); setActiveKey(key);
  };
  const Page = PAGES[isEmployee ? "leave" : active];
  const refresh = () => setRefreshKey((k) => k + 1);

  return (
    <div className="app-shell">
      <Sidebar {...{ active, setActive, collapsed, setCollapsed }} />
      <div className="app-body">
        <Header active={active} onNew={() => setModal("project")} onQuickPay={() => setModal("payment")} />
        <Page key={`${active}-${refreshKey}-${openProject || ""}`} setActive={setActive} initialProject={openProject} company={company} setCompany={setCompany} onNew={() => setModal("project")} onDone={refresh} />
      </div>
      {modal === "project" && <NewProjectModal close={() => setModal(null)} refresh={refresh} />}
      {modal === "payment" && <QuickPaymentModal close={() => setModal(null)} onSaved={refresh} />}
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default function App() {
  return <AuthProvider><Shell /></AuthProvider>;
}
